const config = {
	env: {
		base_url: process.env.BASE_URL,
		node_env: process.env.NODE_ENV
	},
	routeMode: 'history', //hash 模式 history 模式
	api: {
		host: 'https://api.51good.com',
		crossDomain: true,
		timeout: 60000
	},
	cookie: {
		TokenKey: 'Ganyu-Token',
		setting: {
			domain: '51good.com',
			expires: 1,
			path: '/',
			secure:false
		}
	},
	domain: {
		app: 'https://www.51good.com',
		master: 'https://master.51good.com'
	}
}


export default config




// WEBPACK FOOTER //
// ./src/config/app.js